import React, { Fragment } from 'react';
import RevisedAndPublished from '../RevisedAndPublished';

const ContentHistoryListItem = (props) => {
  const lastItem = props.isLast ? (
    <span id={props.lastListItemId} tabIndex="-1" />
  ) : null;

  return (
    <Fragment>
      {props.largeList ? (
        <li className="content-history__item" key={props.index}>
          <a href={props.Url}>{props.Heading}</a>
          <RevisedAndPublished
            isNew={props.IsNew}
            subjectHeading={props.SubjectHeading}
            translations={props.translations}
            eventDate={props.EventDate}
          />
          {lastItem}
        </li>
      ) : (
        <li className="content-history__simplified-item">
          <a href={props.Url}>{props.Heading}</a>
          <span>
            {' '}
            ({props.SubjectHeading ? `${props.SubjectHeading}, ` : null}
            {props.EventDate})
          </span>
          {lastItem}
        </li>
      )}
    </Fragment>
  );
};

export default ContentHistoryListItem;
